export const handleClick = (event: any) => {
    const target = event.target as HTMLElement;
    let content;
    const includedAccordionHeader = target.className.toLowerCase().includes('accordion-heading');

    if (target.tagName.toLowerCase() === 'a' || includedAccordionHeader) {
        const accordionHeading = includedAccordionHeader ? target : target.parentElement;

        const link = accordionHeading?.querySelector('a');

        const href = link?.getAttribute('href');

        if (href?.indexOf('#') === 0) {
            event.preventDefault();
            content = document.getElementById(href.substring(1));
            if (content?.classList.contains('expand')) {
                content?.classList.remove('expand');
                accordionHeading?.classList?.remove('expand-accordion');
            } else {
                content?.classList.add('expand');
                accordionHeading?.classList?.add('expand-accordion');
            }
        }
    }
};
